import { render } from "./TFAView.vue?vue&type=template&id=fffcdbc8"
import script from "./TFAView.vue?vue&type=script&lang=js"
export * from "./TFAView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__